import React, { useEffect, useState } from "react";
import { Box, Grid, Stack } from "@mui/material";
import { SwiperSlide } from "swiper/react";
import { DynamicTable } from "./DynamicTable";
import VSNTypography from "../../../../shared/VSNTypography";
import { VSNSwiper } from "../../../../shared/VSNSwiper";
import { PhysicalOnePagerResultStyle } from "../PhysicalOnePagerResultStyle";
import {
  CPETGaugeCharts,
  CPETSecondChart,
  DynamicVO2Chart,
} from "../../../assessment/CPETChartCommonComponent";

const CPETResults = ({ data }) => {
  const classes = PhysicalOnePagerResultStyle();
  const [reRender, setReRender] = useState(false);
  useEffect(() => {
    setReRender(true);
  }, []);

  return (
    <Stack className={classes.assessmentReportCard}>
      <Grid container spacing={3}>
        <Grid item xl={6} lg={12} xs={12}>
          <Stack
            sx={{ backgroundColor: "#FFFFFF" }}
            borderRadius="10px"
            padding={{ md: "40px", xs: "20px" }}
            gap={{ sm: "55px", xs: "30px" }}
            className={classes.assessmentReportCard}
          >
            <Stack
              direction="row"
              flexWrap="wrap"
              justifyContent="space-between"
            >
              {data?.gauge_charts?.map((item, index) => (
                <CPETGaugeCharts key={index} data={item} />
              ))}
            </Stack>

            <Stack direction="row" flexWrap="wrap" gap={1}>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing="8px"
              >
                <Stack height="100%" width="100%" justifyContent="center">
                  <Box
                    sx={{
                      backgroundColor: "#FDE9C8",
                      width: 16,
                      height: 16,
                      borderRadius: "4px",
                    }}
                  />
                </Stack>
                <VSNTypography fontSize={{ xs: 14, sm: 16 }}>
                  Actual
                </VSNTypography>
              </Stack>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing="8px"
              >
                <Stack height="100%" width="100%" justifyContent="center">
                  <Box
                    sx={{
                      backgroundColor: "#C3EFD1",
                      width: 16,
                      height: 16,
                      borderRadius: "4px",
                    }}
                  />
                </Stack>
                <VSNTypography fontSize={{ xs: 14, sm: 16 }}>
                  Predicted{" "}
                </VSNTypography>
              </Stack>
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing="8px"
              >
                <Stack height="100%" width="100%" justifyContent="center">
                  <Box
                    sx={{
                      backgroundColor: "#34A259",
                      width: 16,
                      height: 16,
                      borderRadius: "4px",
                    }}
                  />
                </Stack>
                <VSNTypography fontSize={{ xs: 14, sm: 16 }}>
                  Better
                </VSNTypography>
              </Stack>
            </Stack>
          </Stack>
        </Grid>

        <Grid item xl={6} lg={12} xs={12}>
          <DynamicTable tableData={data?.table_data} />
        </Grid>
        <Grid item xl={12} lg={12} xs={12}>
          <Box position="relative">
            <Stack
              direction="row"
              spacing={1.4}
              className={`${classes.VitalcustomArrow} ${classes.customArrow}`}
            >
              <div className="swiper-button image-swiper-button-next" />
              <div className="swiper-button image-swiper-button-prev" />
            </Stack>
            <VSNSwiper
              className={classes.containerCard}
              navigation={{
                prevEl: ".image-swiper-button-next",
                nextEl: ".image-swiper-button-prev",
                disabledClass: "swiper-button-disabled",
              }}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                600: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                992: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1200: {
                  slidesPerView: 2,
                  spaceBetween: 25,
                },
                1600: {
                  slidesPerView: 2.3,
                  spaceBetween: 25,
                },
              }}
            >
              <Box sx={{ margin: "30px" }}>
                {data?.charts?.map((ele, index) => (
                  <SwiperSlide key={index}>
                    <Box
                      sx={{
                        backgroundColor: "#ffffff",
                        padding: { sm: "24px", xs: "16px" },
                        borderRadius: "8px",
                        width: "100%",
                      }}
                    >
                      <VSNTypography
                        mb={{ sm: 0, xs: 2 }}
                        sx={{ fontSize: "24px", fontWeight: 700 }}
                      >
                        {ele?.title}
                      </VSNTypography>
                      <Stack direction="row" gap={2} flexWrap="wrap">
                        {ele?.legend?.map((item, index) => (
                          <Stack
                            direction="row"
                            justifyContent="center"
                            alignItems="center"
                            gap={1}
                            flexWrap="wrap"
                            key={index}
                          >
                            <Stack
                              height="auto"
                              width="auto"
                              justifyContent="center"
                            >
                              <Box
                                sx={{
                                  backgroundColor: item?.color,
                                  width: 16,
                                  height: 16,
                                  borderRadius: "4px",
                                }}
                              />
                            </Stack>
                            <VSNTypography fontSize={{ sm: 16, xs: 14 }}>
                              {item?.label}
                            </VSNTypography>
                          </Stack>
                        ))}
                      </Stack>
                      <Box sx={{ maxWidth: "860px" }}>
                        {ele?.title === "Cardiac Output vs Oxygen Uptake" ? (
                          <Box sx={{ maxWidth: "860px" }}>
                            {reRender && (
                              <CPETSecondChart
                                key={index}
                                chartData={ele}
                                height="400px"
                              />
                            )}
                          </Box>
                        ) : (
                          <Box sx={{ maxWidth: "860px" }}>
                            {reRender && (
                              <DynamicVO2Chart
                                key={index}
                                chartData={ele}
                                height="400px"
                              />
                            )}
                          </Box>
                        )}
                      </Box>
                      <VSNTypography>{ele?.description}</VSNTypography>
                      <VSNTypography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 700,
                          color: "var(--gray)",
                        }}
                        mt={3}
                      >
                        {ele?.info ?? ""}
                      </VSNTypography>
                    </Box>
                  </SwiperSlide>
                ))}
              </Box>
            </VSNSwiper>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default CPETResults;
